import { PaymentType } from '../types';

export namespace SystemUsersPaymentsMapper {
  export function toFront(data: PaymentType[]) {
    return data.map((payment) => {
      return { ...payment, total: payment.total / 100, discount: payment.discount / 100 };
    });
  }
}
